module.exports = __webpack_public_path__ + "instagram_icon.png?66b2a363053f2f8230c8e84d7f5582ac";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instagram_icon.png
// module id = 26
// module chunks = 24